$(function(){
  $(document).on('click', ".js-submit-favorite-job", function(e) {
    $(this).prop("disabled", true);
    let jobTarget = $(this).data('job_id');
    let type = $(this).hasClass('favorite') ? 'un-favorite' : 'favorite'
    saveFavoriteJob(jobTarget, $(this), type);
  });

  function saveFavoriteJob(job_id, button, type = 'favorite') {
    let url = type === 'favorite' ? Routes.create_favorite_jobs_path() : Routes.destroy_favorite_jobs_path()
    return $.ajax({
      type: "POST",
      url: url,
      data: {
        authenticity_token: $("meta[name=csrf-token]").prop("content"),
        job_id: job_id,
      }
    }).done(function (response) {
      if (response.save) {
        if (response.count == 0 || response.count == "") {
          $('.blank-favorite-area').removeClass('d-none')
          $('.favorite_jobs_info').addClass('d-none')
        }
        $(".js-count-favorite-job").text(response.count)
        if (type === 'favorite') {
          $(button).addClass('favorite')
        } else {
          $(button).closest(".job_card").hide('slow', function(){ $(this).remove(); });
          $(button).removeClass('favorite')
        }
      } else {
        $("#job_favorite_alert").removeClass('d-none')
        window.scrollTo({top: 0, behavior: 'smooth'});
      }
      $(button).prop("disabled", false);
    }).fail(function (errorThrown) {
    });
  }
});